import React from 'react';

import imageNotFound from "../../assets/img/not_found.png";
import "./styles.css";

const SearchNotFound = ({message = "Nenhum conteúdo disponível no momento.", onClick, buttonMessage}) => (
  <div className={"notFoundPresentialCourses"}>
    <img src={imageNotFound} alt="Nenhum conteúdo disponível no momento"/>
    <h3>{message}</h3>
    <button data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name={message} onClick={onClick}>{buttonMessage}</button>
  </div>
)

export default SearchNotFound;


// WEBPACK FOOTER //
// ./src/components/SearchNotFound/index.js